import classNames from 'classnames/bind';
import { FC, memo } from 'react';
import styles from '../../Search.module.scss';

const cx = classNames.bind(styles);

interface FormContainerProps {
  children: React.ReactNode;
  className?: string;
}

export const FormContainer: FC<FormContainerProps> = memo(
  ({ children, className }) => {
    return (
      <div className={cx('form-column', className)}>
        <div className={cx('form-field')}>{children}</div>
      </div>
    );
  }
);

FormContainer.displayName = 'FormContainer';
